export default {
    setUser(state, payload) {
        state.token = payload.token;
        state.talic = payload.talic;
    }
};